export default "__VITE_PUBLIC_ASSET__527ced8d__"